//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Breadcrumbs } from '~/plugins/breadcrumbs'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import FaqItems from '~/components/Flotillas/FaqItems'

export default {
  name: 'LetYourBoat',
  mixins: [pageMeta],
  components:{
    FaqItems,
  },
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      await mxGetMeta(ctx, {
        meta: {
          method: 'static'
        }
      })
      const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [{
        title: ctx.app.i18n.t('rent-out-your-boat'),
        url: ctx.route.fullPath
      }])
      await ctx.store.dispatch('setBreadcrumbs', crubms)
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      faq: {
        items: [
          {
            question: this.$t('what-do-i-have-to-do-when'),
            answer: this.$t('when-you-receive-a-bookin')
          },
          {
            question: this.$t('how-do-i-communicate-with'),
            answer: this.$t('to-ensure-your-safety-it')
          },
          {
            question: this.$t('when-do-i-get-paid-for-a'),
            answer: this.$t('tubber-controlled-profess')
          },
          {
            question: this.$t('what-price-should-i-set-f'),
            answer: this.$t('the-price-is-completely-u')
          },
          {
            question: this.$t('who-can-add-a-boat-'),
            answer: this.$t('only-the-rightful-owner-c')
          },
          {
            question: this.$t('what-are-the-responsibili'),
            answer: this.$t('as-the-owner-you-are-res')
          },
          {
            question: this.$t('how-do-i-update-my-list-'),
            answer: this.$t('on-the-page-of-your-boat')
          }
        ]
      }
    }
  }
}
